import React, { useState, useEffect } from "react";
import { format, differenceInDays } from "date-fns";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, withRouter } from "react-router-dom";
import queryString from "query-string";
import classNames from "classnames";
import { CSVLink } from "react-csv";
import faker from "faker";
import _ from "lodash";
import { saveAs } from "file-saver";
import CSVReader from "react-csv-reader";
import { SubmitLocalStorageSearch } from "../../function";
import numeral from "numeral";
import {
  pdf,
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
  Font,
} from "@react-pdf/renderer";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import font from "../../styles/Sarabun-Regular.ttf";
import fontBold from "../../styles/Sarabun-Bold.ttf";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { EmitterStatus } from "../../event";
import Swal from "sweetalert2";
import ReactExport from "react-data-export";
import { checkRole } from "../../utils/role";

// Lotte
import Lottie from "react-lottie";
import Loading from "../../animation/loading.json";

// REDUX
import { onChangeSearchBar } from "../../_redux/searchBarSlice";

// HOOKS
import useGetLoan from "../../hooks/useGetLoan";
import useGetLoanCount from "../../hooks/useGetLoanCount";
import useLoanSandbox from "../../hooks/useLoanSandbox";

// COMPONENTS
import ContainerContent from "../Container/ContainerContent";
import LoadingPage from "../Loading/LoadingPage";
import LoanSandboxTable from "../LoanSandbox/LoanSandboxTable";
import PrevPage from "../../components/Pagination/PrevPage";
import NumberPage from "../../components/Pagination/NumberPage";
import NextPage from "../../components/Pagination/NextPage";
import SelectRows from "../../components/Pagination/SelectRows";
import DataEmpty from "../DataEmpty";

// UTILS
import {
  getCurrentLocalDateTime,
  months,
  pad,
} from "../../utils/getLocalDateTime";

// AWS
import { API, Auth, Storage } from "aws-amplify";
import AWS from "aws-sdk";
import { getHeaderTUDF } from "utils/buro";
import { getDetailSegment } from "utils/buro";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const optionsPackage = [
  {
    label: "All Package",
    value: "All",
  },
  {
    label: "อุปโภค / บริโภค",
    value: "อุปโภค / บริโภค",
  },
  {
    label: "ท่องเที่ยว",
    value: "ท่องเที่ยว",
  },
  {
    label: "ธุรกิจ",
    value: "ธุรกิจ",
  },
];

const optionsStatus = [
  {
    label: "All Status",
    value: "All",
  },
  {
    label: "ACTIVE",
    value: "ACTIVE",
  },
  {
    label: "DONE",
    value: "DONE",
  },
  {
    label: "LATE",
    value: "LATE",
  },
  {
    label: "PENDING",
    value: "PENDING",
  },
  {
    label: "REFINANCE",
    value: "REFINANCE",
  },
  {
    label: "FAIL",
    value: "FAIL",
  },
];

const optionsLimit = [
  {
    label: 50,
    value: 50,
  },
  { label: 100, value: 100 },
  { label: 150, value: 150 },
  { label: 200, value: 200 },
  { label: 250, value: 250 },
  { label: 300, value: 300 },
  { label: 350, value: 350 },
  { label: 400, value: 400 },
  { label: 450, value: 450 },
  { label: 500, value: 500 },
  { label: 1000, value: 1000 },
];

const optionsReserve = [
  {
    label: "ทั้งหมด",
    value: "ALL",
  },
  { label: "จอง (แสดงเฉพาะของตัวเอง)", value: "RESERVE" },
  { label: "ยังไม่ได้จอง", value: "NOT_RESERVE" },
];

function Sandbox5(props) {
  const Limit = 50;
  const dispatch = useDispatch();
  const router = useHistory();
  const search = router.location.search;

  const { user } = useSelector((state) => state.initializeApp);

  const today = getCurrentLocalDateTime();
  const nextWeek = new Date();
  const preWeek = new Date();

  nextWeek.setDate(new Date().getDate() + 7);
  // nextWeek.setFullYear(nextWeek.getFullYear() + 10);
  preWeek.setDate(new Date().getDate() - 7);
  const defaultMaxOverdueDate = getCurrentLocalDateTime(
    new Date(+today.year, today.monthIndex, +today.date)
  );
  const defaultMinOverdueDate = getCurrentLocalDateTime(
    new Date(+today.year, today.monthIndex, +today.date)
  );
  const defaultPayDate = today.fullDate;
  const defaultBeginOverdueDate = getCurrentLocalDateTime(preWeek);
  const defaultEndOverdueDate = getCurrentLocalDateTime(nextWeek);

  const querySearch = queryString.parse(search);

  const DEFAULT_QUERY = {
    Limit,
    countData: 1,
    paid_date: defaultPayDate,
    package: optionsPackage[0].value,
    status: optionsStatus[1].value,
    // min_created: defaultBeginOverdueDate.fullDate,
    // max_created: defaultEndOverdueDate.fullDate,
    min_created: "",
    max_created: "",
    overDueDate: today.fullDate,
    SELECT_ALL: true,
    sandbox: "5",
  };

  const [currentDate, setCurrentDate] = useState(
    format(new Date("2021-05-31"), "yyyy-MM-dd")
  );

  const { datas, loading, error, getData, count } = useLoanSandbox({
    ...DEFAULT_QUERY,
    currentDate,
  });

  const [searchBy, setSearchBy] = useState("request_id");
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState({ value: Limit, label: Limit });
  const [pageType, setPageType] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [loadingImport, setLoadingImport] = useState(false);
  const [dataExport, setDataExport] = useState([]);
  const [loadingExport, setLoadingExport] = useState(false);

  const [query, setQuery] = useState(DEFAULT_QUERY);

  if (loading)
    return (
      <ContainerContent>
        <LoadingPage />
      </ContainerContent>
    );
  if (error) return <p className="text-black">Error</p>;

  const onSelect = (name) => (e) => {
    const { value } = e;
    setQuery((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const onField = (e) => {
    const { name, value } = e.target;
    setQuery((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const onClickGetLoan = async () => {
    // try {
    //   await API.post(
    //     "MoneyHubAdmin",
    //     "/loan/sandbox/L0816942455_121064_1853_1",
    //     {
    //       body: {},
    //       headers: {
    //         Authorization: `Bearer ${(await Auth.currentSession())
    //           .getIdToken()
    //           .getJwtToken()}`,
    //       },
    //     }
    //   );
    // } catch (error) {
    //   console.log("click get loan", error);
    // }

    const ranRequestAmountList = [
      5000, 6000, 7000, 8000, 9000, 10000, 15000, 20000, 30000, 50000,
    ];
    const ranPeriodList = [3, 6, 12];
    const ranPurposeList = ["ธุรกิจ", "อุปโภค / บริโภค", "ท่องเที่ยว"];

    const ranRequestAmountIndex = Math.floor(
      Math.random() * ranRequestAmountList.length
    );
    const ranPeriodIndex = Math.floor(Math.random() * ranPeriodList.length);
    const ranPurposeIndex = Math.floor(Math.random() * ranPurposeList.length);

    const phone_number = "0819278409";
    const executeTime = getCurrentLocalDateTime(new Date(currentDate)).date;

    // const name = faker.name.firstName();
    // const lastname = faker.name.lastName();
    const name = faker.name.firstName();
    const lastname = faker.name.lastName();
    const data = [
      {
        name: "พนิต",
        lastname: "จ๋วงพานิช",
        citizenid: "4557769844752",
        birthdateTh: "01/06/2533",
        currentAddress: "929,คลองจั่น,บางกะปิ,กรุงเทพมหานคร,10240",
        period: 12,
        requestamount: 6000,
        payPerMonth: 6000,
        completedAt: "15",
        request_id: getCurrentLocalDateTime(new Date("2020-07-15")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2020-07-15")).isoDateTime,
        toDayTestGenLoan: "2020-07-15",
      },
      {
        name: "ปนัดดา",
        lastname: "อยู่ดี",
        citizenid: "3365466155871",
        birthdateTh: "05/02/2534",
        currentAddress: "429,หัวหมาก,บางกะปิ,กรุงเทพมหานคร,10250",
        period: 3,
        requestamount: 15000,
        payPerMonth: 15000,
        completedAt: "09",
        request_id: getCurrentLocalDateTime(new Date("2021-04-09")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2021-04-09")).isoDateTime,
        toDayTestGenLoan: "2021-04-09",
      },
      {
        name: "สมชาย",
        lastname: "เปลี่ยนสี",
        citizenid: "3051499825492",
        birthdateTh: "07/04/2513",
        currentAddress: "14,ท่าข้าม,บางขุนเทียน,กรุงเทพมหานคร,10150",
        period: 6,
        requestamount: 18000,
        payPerMonth: 18000,
        completedAt: "12",
        request_id: getCurrentLocalDateTime(new Date("2021-02-12")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2021-02-12")).isoDateTime,
        toDayTestGenLoan: "2021-02-12",
      },
      {
        name: "ไกรศร", //ข้ามปีผิด
        lastname: "อันโอชา",
        citizenid: "9042595648601",
        birthdateTh: "08/01/2508",
        currentAddress: "54,ศรีดงเย็น,ไชยปราการ,เชียงใหม่,50320",
        period: 12,
        requestamount: 12000,
        payPerMonth: 12000,
        completedAt: "01",
        request_id: getCurrentLocalDateTime(new Date("2020-12-01")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2020-12-01")).isoDateTime,
        toDayTestGenLoan: "2020-12-01",
      },
      {
        name: "ยง",
        lastname: "ไกรบุตร",
        citizenid: "9187168852291",
        birthdateTh: "25/12/2527",
        currentAddress: "131,ฉลุง,หาดใหญ่,สงขลา,90110",
        period: 6,
        requestamount: 30000,
        payPerMonth: 30000,
        completedAt: "13",
        request_id: getCurrentLocalDateTime(new Date("2021-01-13")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2021-01-13")).isoDateTime,
        toDayTestGenLoan: "2021-01-13",
      },
      {
        name: "ธีระ",
        lastname: "มั่งมี",
        citizenid: "8072666106271",
        birthdateTh: "16/08/2540",
        currentAddress: "15,หนองโก,กระนวน,ขอนแก่น,40170",
        period: 6,
        requestamount: 12000,
        payPerMonth: 12000,
        completedAt: "12",
        request_id: getCurrentLocalDateTime(new Date("2020-12-12")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2020-12-12")).isoDateTime,
        toDayTestGenLoan: "2020-12-12",
      },
      {
        name: "พิชาญ",
        lastname: "บัวบาง",
        citizenid: "1383925076366",
        birthdateTh: "23/03/2530",
        currentAddress: "97,เมือง,เมือง,เลย,42000",
        period: 12,
        requestamount: 12000,
        payPerMonth: 12000,
        completedAt: "15",
        request_id: getCurrentLocalDateTime(new Date("2020-07-15")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2020-07-15")).isoDateTime,
        toDayTestGenLoan: "2020-07-15",
      },
      {
        name: "ชัยพร",
        lastname: "คุ้มเพชร",
        citizenid: "9549604855203",
        birthdateTh: "17/04/2543",
        currentAddress: "66,แม่ใจ,แม่ใจ,พะเยา,56130",
        period: 3,
        requestamount: 6000,
        payPerMonth: 6000,
        completedAt: "15",
        request_id: getCurrentLocalDateTime(new Date("2021-03-15")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2021-03-15")).isoDateTime,
        toDayTestGenLoan: "2021-03-15",
      },
      {
        name: "ประเวศ",
        lastname: "ชั่งทอง",
        citizenid: "9953255318250",
        birthdateTh: "11/03/2541",
        currentAddress: "11,แม่ยม,เมืองแพร่,แพร่,54000",
        period: 6,
        requestamount: 9000,
        payPerMonth: 9000,
        completedAt: "10",
        request_id: getCurrentLocalDateTime(new Date("2021-04-10")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2021-04-10")).isoDateTime,
        toDayTestGenLoan: "2021-04-10",
      },
      {
        name: "พรชัย",
        lastname: "โปร่งพรมมา",
        citizenid: "6035143401509",
        birthdateTh: "15/04/2538",
        currentAddress: "74,แม่สา,เวียงสา,น่าน,55110",
        period: 12,
        requestamount: 16000,
        payPerMonth: 16000,
        completedAt: "05",
        request_id: getCurrentLocalDateTime(new Date("2021-01-05")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2021-01-05")).isoDateTime,
        toDayTestGenLoan: "2021-01-05",
      },
      {
        name: "อรอนง",
        lastname: "แก้วสว่าง",
        citizenid: "2258093945584",
        birthdateTh: "09/06/2534",
        currentAddress: "114,บางบำหรุ,บางพลัด,กรุงเทพมหานคร,10700",
        period: 3,
        requestamount: 15000,
        payPerMonth: 15000,
        completedAt: "10",
        request_id: getCurrentLocalDateTime(new Date("2021-04-10")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2021-04-10")).isoDateTime,
        toDayTestGenLoan: "2021-04-10",
      },
      {
        name: "สมพง",
        lastname: "รอดกสิกรรม",
        citizenid: "5889449024824",
        birthdateTh: "30/04/2538",
        currentAddress: "99,บางกรวย,บางกรวย,นนทบุรี,11130",
        period: 3,
        requestamount: 30000,
        payPerMonth: 30000,
        completedAt: "10",
        request_id: getCurrentLocalDateTime(new Date("2021-05-10")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2021-05-10")).isoDateTime,
        toDayTestGenLoan: "2021-05-10",
      },
      {
        name: "อาคม",
        lastname: "สุทธิ",
        citizenid: "7795906360876",
        birthdateTh: "07/08/2540",
        currentAddress: "88,รังสิต,ธัญบุรี,ปทุมธานี12110",
        period: 3,
        requestamount: 9000,
        payPerMonth: 9000,
        completedAt: "10",
        request_id: getCurrentLocalDateTime(new Date("2021-03-10")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2021-03-10")).isoDateTime,
        toDayTestGenLoan: "2021-03-10",
      },
      {
        name: "อานน",
        lastname: "มีสุข",
        citizenid: "5724088677310",
        birthdateTh: "03/03/2536",
        currentAddress: "63,สามแยก,เลิกนกทา,ยโสธร,35120",
        period: 6,
        requestamount: 6000,
        payPerMonth: 6000,
        completedAt: "10",
        request_id: getCurrentLocalDateTime(new Date("2020-12-10")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2020-12-10")).isoDateTime,
        toDayTestGenLoan: "2020-12-10",
      },
      {
        name: "ทศ",
        lastname: "พรมมา",
        citizenid: "3671764290592",
        birthdateTh: "23/06/2519",
        currentAddress: "67,อ่างศิลา,เมืองชลบุรี,ชลบุรี,20000",
        period: 12,
        requestamount: 12000,
        payPerMonth: 12000,
        completedAt: "10",
        request_id: getCurrentLocalDateTime(new Date("2020-06-10")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2020-06-10")).isoDateTime,
        toDayTestGenLoan: "2020-06-10",
      },
      {
        name: "สมปอง",
        lastname: "มณีโชติ",
        citizenid: "7723005934781",
        birthdateTh: "12/04/2523",
        currentAddress: "77,ห้วยแร้ง,เมืองตราด,ตราด,23000",
        period: 6,
        requestamount: 6000,
        payPerMonth: 6000,
        completedAt: "10",
        request_id: getCurrentLocalDateTime(new Date("2021-04-10")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2021-04-10")).isoDateTime,
        toDayTestGenLoan: "2021-04-10",
      },
      {
        name: "ปรเมศ",
        lastname: "แก้วเพชร",
        citizenid: "6458528626917",
        birthdateTh: "23/09/2532",
        currentAddress: "78,น้ำผุด,เมืองตรัง,ตรัง,92000",
        period: 12,
        requestamount: 12000,
        payPerMonth: 12000,
        completedAt: "10",
        request_id: getCurrentLocalDateTime(new Date("2020-10-10")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2020-10-10")).isoDateTime,
        toDayTestGenLoan: "2020-10-10",
      },
      {
        name: "อวยชัย",
        lastname: "จำปาทอง",
        citizenid: "3653492374912",
        birthdateTh: "24/04/2519",
        currentAddress: "87,เกะรอ,รามัน,ยะลา,95140",
        period: 6,
        requestamount: 12000,
        payPerMonth: 12000,
        completedAt: "10",
        request_id: getCurrentLocalDateTime(new Date("2021-04-10")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2021-04-10")).isoDateTime,
        toDayTestGenLoan: "2021-04-10",
      },
      {
        name: "พรเทพ",
        lastname: "จันทร์มี",
        citizenid: "5866611438037",
        birthdateTh: "08/11/2539",
        currentAddress: "64,ตลุก,สรรพยา,ชัยนาท,17150",
        period: 3,
        requestamount: 24000,
        payPerMonth: 24000,
        completedAt: "10",
        request_id: getCurrentLocalDateTime(new Date("2021-03-10")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2021-03-10")).isoDateTime,
        toDayTestGenLoan: "2021-03-10",
      },
      {
        name: "ดอน",
        lastname: "ชูนำชัย",
        citizenid: "8417404116416",
        birthdateTh: "31/07/2542",
        currentAddress: "33,หลักฟ้า,ไชโย,อ่างทอง,14140",
        period: 6,
        requestamount: 18000,
        payPerMonth: 18000,
        completedAt: "02",
        request_id: getCurrentLocalDateTime(new Date("2021-04-02")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2021-04-02")).isoDateTime,
        toDayTestGenLoan: "2021-04-02",
      },
    ];

    const data2 = [
      {
        name: "พิชาน",
        lastname: "แซ่คู",
        citizenid: "1101401711216",
        birthdateTh: "01/06/2533",
        currentAddress:
          "30 ซอยลาดพร้าว 91 ถนนลาดพร้าว แขวงคลองเจ้าคุณสิงห์ เขตวังทองหลาง จ.กรุงเทพฯ 10310",
        period: 3,
        requestamount: 24000,
        payPerMonth: 24000,
        completedAt: "10",
        phone_number: "0875003282",
        bankNo: "7302824813",
        loan_kbank_id: "94000001",
        request_id: getCurrentLocalDateTime(new Date("2021-02-10")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2021-02-10")).isoDateTime,
        toDayTestGenLoan: "2021-02-10",
        // completedAt: getCurrentLocalDateTime(new Date(currentDate)).date,
        // phone_number: "0875003282",
        // bankNo: "7302824813",
        // loan_kbank_id: "94000001",
        // request_id: getCurrentLocalDateTime(new Date(currentDate)).isoDateTime,
        // dueTime: getCurrentLocalDateTime(new Date(currentDate)).isoDateTime,
        // toDayTestGenLoan: getCurrentLocalDateTime(new Date(currentDate))
        //   .isoDateTime,
      },
      // {
      //   name: "ชยุตม์",
      //   lastname: "ปิยะวงศ์ไพบูลย์",
      //   citizenid: "1100800862918",
      //   birthdateTh: "01/06/2534",
      //   currentAddress:
      //     "511/854 ถ.จรัญสนิทวงศ์ แขวงบางขุนศรี เขตบางกอกน้อย จ.กรุงเทพฯ 10700",
      //   period: 6,
      //   requestamount: 18000,
      //   payPerMonth: 18000,
      //   completedAt: "02",
      //   phone_number: "0867761082",
      //   bankNo: "0863966698",
      //   loan_kbank_id: "94000002",
      //   request_id: getCurrentLocalDateTime(new Date("2021-04-02")).isoDateTime,
      //   dueTime: getCurrentLocalDateTime(new Date("2021-04-02")).isoDateTime,
      //   toDayTestGenLoan: "2021-04-02",
      // },
      {
        name: "ทรรศนีย์",
        lastname: "ริยาพันธ์",
        citizenid: "1800500038083",
        birthdateTh: "01/06/2538",
        currentAddress: "75 หมู่ที่ 4 ต.กะทูน อ.พิปูน จ.นครศรีธรรมราช 80270",
        period: 6,
        requestamount: 30000,
        payPerMonth: 30000,
        completedAt: "14",
        phone_number: "0856842510",
        bankNo: "0033480903",
        loan_kbank_id: "94000003",
        request_id: getCurrentLocalDateTime(new Date("2021-01-14")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2021-01-14")).isoDateTime,
        toDayTestGenLoan: "2021-01-14",
      },
      {
        name: "สมิตรา",
        lastname: "แก้วคำ",
        citizenid: "1240800149340",
        birthdateTh: "01/06/2530",
        currentAddress:
          "179 หมู่ที่ 5 ต.เมืองเสือ อ.พยัคฆภูมิพิสัย จ.มหาสารคาม 44110",
        period: 12,
        requestamount: 12000,
        payPerMonth: 12000,
        completedAt: "01",
        phone_number: "0639685368",
        bankNo: "0313707288",
        loan_kbank_id: "94000004",
        request_id: getCurrentLocalDateTime(new Date("2020-12-01")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2020-12-01")).isoDateTime,
        toDayTestGenLoan: "2020-12-01",
      },
      {
        name: "รัตนาพร",
        lastname: "นันทะพันธ์",
        citizenid: "1639900348446",
        birthdateTh: "01/06/2528",
        currentAddress: "9 หมู่9 ต.นาโบสถ์ อ.วังเจ้า จ.ตาก 63000",
        period: 12,
        requestamount: 10000,
        payPerMonth: 10000,
        completedAt: "01",
        phone_number: "0985592973",
        bankNo: "0691754863",
        loan_kbank_id: "94000005",
        request_id: getCurrentLocalDateTime(new Date("2020-12-01")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2020-12-01")).isoDateTime,
        toDayTestGenLoan: "2020-12-01",
      },
      {
        name: "ชัยกฤติ์พงษ์",
        lastname: "สุขพันธ์",
        citizenid: "1709900497360",
        birthdateTh: "01/06/2536",
        currentAddress:
          "399 หมู่ 3 ตำบลวังจันทร์ อำเภอแก่งกระจาน จ.เพชรบุรี 76170",
        period: 6,
        requestamount: 6000,
        payPerMonth: 6000,
        completedAt: "10",
        phone_number: "0649461989",
        bankNo: "0251122032",
        loan_kbank_id: "94000006",
        request_id: getCurrentLocalDateTime(new Date("2021-04-10")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2021-04-10")).isoDateTime,
        toDayTestGenLoan: "2021-04-10",
      },
      {
        name: "สุนิสา",
        lastname: "พานเที่ยง",
        citizenid: "1149900495541",
        birthdateTh: "01/06/2537",
        currentAddress:
          "9/2 หมู่ที่ 4 ต.สิงหนาท  อ.ลาดบัวหลวง จ.พระนครศรีอยุธยา 13230",
        period: 6,
        requestamount: 30000,
        payPerMonth: 30000,
        completedAt: "13",
        phone_number: "0884602766",
        bankNo: "1340366428",
        loan_kbank_id: "94000007",
        request_id: getCurrentLocalDateTime(new Date("2021-01-13")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2021-01-13")).isoDateTime,
        toDayTestGenLoan: "2021-01-13",
      },
      {
        name: "ภูวเดช",
        lastname: "รักรุ่งเรือง",
        citizenid: "1103000048143",
        birthdateTh: "01/06/2532",
        currentAddress:
          "100/261 หมู่ 4 แขวงคลองสองต้นนุ่น เขตลาดกระบัง จ.กรุงเทพฯ 10520",
        // period: 6,
        // requestamount: 8357,
        // payPerMonth: 8357,
        // completedAt: "20",
        // phone_number: "0846505167",
        // bankNo: "0882608684",
        // loan_kbank_id: "94000018",
        // request_id: getCurrentLocalDateTime(new Date("2021-05-20")).isoDateTime,
        // dueTime: getCurrentLocalDateTime(new Date("2021-05-20")).isoDateTime,
        // toDayTestGenLoan: "2021-05-20",
        period: 6,
        requestamount: 9000,
        payPerMonth: 9000,
        completedAt: "05",
        phone_number: "0846505167",
        bankNo: "0882608684",
        loan_kbank_id: "94000008",
        request_id: getCurrentLocalDateTime(new Date("2021-01-05")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2021-01-05")).isoDateTime,
        toDayTestGenLoan: "2021-01-05",
      },
      {
        name: "ณัฐรดี",
        lastname: "งับสันเทียะ",
        citizenid: "1770500075257",
        birthdateTh: "01/06/2539",
        currentAddress:
          "29/80 ซอย รัชดาภิเษก 30 แยก 1-1 แขวง จันทรเกษม เขต จตุจักร จ.กรุงเทพฯ 10900",
        period: 3,
        requestamount: 6000,
        payPerMonth: 6000,
        completedAt: "03",
        phone_number: "0911695567",
        bankNo: "1028871240",
        loan_kbank_id: "94000009",
        request_id: getCurrentLocalDateTime(new Date("2016-02-03")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2016-02-03")).isoDateTime,
        toDayTestGenLoan: "2016-02-03",
      },
      {
        name: "ภัทรมน",
        lastname: "สุคนธปฏิภาค",
        citizenid: "1104200098749",
        birthdateTh: "01/06/2532",
        currentAddress:
          "34/4 ซอยงามวงศ์วาน47 แยก10-1 แขวงทุ่งสองห้อง เขตหลักสี่ จ.กรุงเทพฯ 10210",
        period: 3,
        requestamount: 5000,
        payPerMonth: 5000,
        completedAt: "20",
        phone_number: "0896949161",
        bankNo: "1011519438",
        loan_kbank_id: "94000010",
        request_id: getCurrentLocalDateTime(new Date("2021-02-20")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2021-02-20")).isoDateTime,
        toDayTestGenLoan: "2021-02-20",
        // period: 3,
        // requestamount: 3000,
        // payPerMonth: 3000,
        // completedAt: "20",
        // phone_number: "0896949161",
        // bankNo: "1011519438",
        // loan_kbank_id: "94000021",
        // request_id: getCurrentLocalDateTime(new Date("2021-05-20")).isoDateTime,
        // dueTime: getCurrentLocalDateTime(new Date("2021-05-20")).isoDateTime,
        // toDayTestGenLoan: "2021-05-20",
      },
      {
        name: "พรธัญรัฐ",
        lastname: "ศิริปุลินพงศ์",
        citizenid: "1100400970675",
        birthdateTh: "01/06/2531",
        currentAddress:
          "29/164 หมู่บ้านวรารักษ์ ซอย 2/5 ต.คลองสาม อ.คลองหลวง จ.ปทุมธานี 12120",
        period: 12,
        requestamount: 6000,
        payPerMonth: 6000,
        completedAt: "15",
        phone_number: "0819595354",
        bankNo: "1018500236",
        // loan_kbank_id: "94000031",
        loan_kbank_id: "94000011",
        request_id: getCurrentLocalDateTime(new Date("2020-07-15")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2020-07-15")).isoDateTime,
        toDayTestGenLoan: "2020-07-15",
      },
      {
        name: "ชไมพร",
        lastname: "พรมเมือง",
        citizenid: "1480200064597",
        birthdateTh: "01/06/2531",
        currentAddress:
          "21 ส.เจริญคอร์ต ถ.พหลโยธิน แขวงพญาไท เขตพญาไท จ.กรุงเทพฯ 10400",
        period: 3,
        requestamount: 15000,
        payPerMonth: 15000,
        completedAt: "09",
        phone_number: "0661469544",
        bankNo: "1001160423",
        loan_kbank_id: "94000012",
        request_id: getCurrentLocalDateTime(new Date("2021-04-09")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2021-04-09")).isoDateTime,
        toDayTestGenLoan: "2021-04-09",
      },
      {
        name: "วรนภ",
        lastname: "พึ่งมา",
        citizenid: "1102003042374",
        birthdateTh: "01/06/2531",
        currentAddress: "22/2 หมู่ 10 ต.คลองข่อย อ.ปากเกร็ด จ.นนทบุรี 11120",
        period: 6,
        requestamount: 12000,
        payPerMonth: 12000,
        completedAt: "16",
        phone_number: "0830392176",
        bankNo: "0218062210",
        loan_kbank_id: "94000013",
        request_id: getCurrentLocalDateTime(new Date("2020-09-16")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2020-09-16")).isoDateTime,
        toDayTestGenLoan: "2020-09-16",
        purpose: "อุปโภค / บริโภค",
      },
      {
        name: "ปิยพร",
        lastname: "จงจิตร",
        citizenid: "1103701842636",
        birthdateTh: "01/06/2531",
        currentAddress:
          "95 ลาดพร้าวซอย 8 ถนนลาดพร้าว แขวงจอมพล เขตจตุจักร จ.กรุงเทพฯ 10900",
        period: 3,
        requestamount: 6000,
        payPerMonth: 6000,
        completedAt: "15",
        phone_number: "0838290092",
        bankNo: "1018868012",
        loan_kbank_id: "94000014",
        request_id: getCurrentLocalDateTime(new Date("2021-03-15")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2021-03-15")).isoDateTime,
        toDayTestGenLoan: "2021-03-15",
      },
      {
        name: "นุชจรินทร์",
        lastname: "คงเกษม",
        citizenid: "1100501029114",
        birthdateTh: "01/06/2533",
        currentAddress:
          "53/586 หมู่13 ถนนพหลโยธิน ต.คลองหนึ่ง อ.คลองหลวง จ.ปทุมธานี 12120",
        period: 12,
        requestamount: 16000,
        payPerMonth: 16000,
        completedAt: "05",
        phone_number: "0972505710",
        bankNo: "0933939707",
        loan_kbank_id: "94000015",
        request_id: getCurrentLocalDateTime(new Date("2021-01-05")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2021-01-05")).isoDateTime,
        toDayTestGenLoan: "2021-01-05",
      },
      {
        name: "สมชาย",
        lastname: "จันทปัญญา",
        citizenid: "1321000011386",
        birthdateTh: "01/06/2533",
        currentAddress:
          "112/185 หมู่ 8 ซ.หนามแดง ถ.ศรีนครินทร์ ต.บางแก้ว อ.บางพลี จ.สมุทรปราการ 10450",
        period: 3,
        requestamount: 9000,
        payPerMonth: 9000,
        completedAt: "09",
        phone_number: "0865475890",
        bankNo: "5982246476",
        loan_kbank_id: "94000016",
        request_id: getCurrentLocalDateTime(new Date("2021-03-09")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2021-03-09")).isoDateTime,
        toDayTestGenLoan: "2021-03-09",
      },
      {
        name: "ณัฐญา",
        lastname: "ผลพืชน์",
        citizenid: "1100500512253",
        birthdateTh: "01/06/2528",
        currentAddress: "641 แชวงบางมด เขตทุ่งครุ จ.กรุงเทพฯ 10140",
        period: 6,
        requestamount: 6000,
        payPerMonth: 6000,
        completedAt: "10",
        phone_number: "0841686642",
        bankNo: "1001323314",
        loan_kbank_id: "94000017",
        request_id: getCurrentLocalDateTime(new Date("2020-12-10")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2020-12-10")).isoDateTime,
        toDayTestGenLoan: "2020-12-10",
      },
      {
        name: "ณภัสวรรณ",
        lastname: "ทองคำ",
        citizenid: "1349900862606",
        birthdateTh: "01/06/2536",
        currentAddress:
          "เลขที่ 3 อาคาร ลุมพินีวิลล์ คอนโด แขวง อนุสาวรีย์ เขต บางเขน กรุงเทพ 10220",
        period: 12,
        requestamount: 12000,
        payPerMonth: 12000,
        completedAt: "13",
        phone_number: "0831288535",
        bankNo: "4340673583",
        loan_kbank_id: "94000018",
        request_id: getCurrentLocalDateTime(new Date("2021-03-13")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2021-03-13")).isoDateTime,
        toDayTestGenLoan: "2021-03-13",
      },
      {
        name: "อานุภาพ",
        lastname: "สุขเสริม",
        citizenid: "2419901070701",
        birthdateTh: "01/06/2536",
        currentAddress: "160 ลาดพร้าว 101 แยก 50 แขวงคลองจั่น เขตบางกะปิ 10240",
        period: 12,
        requestamount: 12000,
        payPerMonth: 12000,
        completedAt: "30",
        phone_number: "0900318990",
        bankNo: "7302900668",
        loan_kbank_id: "94000019",
        request_id: getCurrentLocalDateTime(new Date("2020-11-30")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2020-11-30")).isoDateTime,
        toDayTestGenLoan: "2020-11-30",
      },
      {
        name: "พรเทพ",
        lastname: "จันทร์มี",
        citizenid: "1112770356213",
        birthdateTh: "01/06/2538",
        currentAddress: "265/195 สิวลีรามคำแหง เขตสะพานสูง แขวงสะพานสูง 10240",
        period: 12,
        requestamount: 12000,
        payPerMonth: 12000,
        completedAt: "20",
        phone_number: "0877908161",
        bankNo: "4100462910",
        loan_kbank_id: "94000020",
        request_id: getCurrentLocalDateTime(new Date("2020-08-20")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2020-08-20")).isoDateTime,
        toDayTestGenLoan: "2020-08-20",
      },
      {
        name: "ภูวเดช",
        lastname: "รักรุ่งเรือง",
        citizenid: "1103000048143",
        birthdateTh: "01/06/2532",
        currentAddress:
          "100/261 หมู่ 4 แขวงคลองสองต้นนุ่น เขตลาดกระบัง จ.กรุงเทพฯ 10520",
        period: 12,
        requestamount: 9000,
        payPerMonth: 9000,
        completedAt: "10",
        phone_number: "0846505167",
        bankNo: "0882608684",
        loan_kbank_id: "94000021",
        request_id: getCurrentLocalDateTime(new Date("2021-05-10")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2021-05-10")).isoDateTime,
        toDayTestGenLoan: "2021-05-10",
      },
    ];

    await Promise.all(
      data2.map(async (item, index) => {
        if (
          index === 8
          // index === 7
          // index === 0
          // index === 9
          // index === 1 ||
          // index === 2 ||
          // index === 3 ||
          // index === 4 ||
          // index === 5
        ) {
          await API.post("MoneyHubAdmin", "/loan/sandbox", {
            body: {
              // phone_number: `08${
              //   Math.floor(Math.random() * 99999999) + 10000000
              // }`,
              // bankNo: _.toString(
              //   Math.floor(Math.random() * 9999999999) + 1000000000
              // ),
              purpose: "ธุรกิจ",
              fullname: `${item.name} ${item.lastname}`,
              promo: 0,
              sandbox: "5",
              ...item,
            },
            headers: {
              Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`,
            },
          });
        }
      })
    );
    // await API.post("MoneyHubAdmin", "/loan", {
    //   body: {
    //     // phone_number: `08${Math.floor(Math.random() * 99999999) + 10000000}`,
    //     // phone_number: `0877908161`,
    //     // bankNo: _.toString(Math.floor(Math.random() * 9999999999) + 1000000000),
    //     // citizenid: _.toString(
    //     //   Math.floor(Math.random() * 9999999999999) + 1000000000000
    //     // ),
    //     // birthdateTh: `${pad(Math.floor(Math.random() * 11))}/${pad(
    //     //   Math.floor(Math.random() * 13)
    //     // )}/${pad(Math.floor(Math.random() * 91)) + 1930}`,
    //     currentAddress: "ดินแดง,ดินแดง,กรุงเทพมหานคร,10400",
    //     request_id: getCurrentLocalDateTime(new Date()).isoDateTime,
    //     purpose: ranPurposeList[ranPurposeIndex],
    //     period: +ranPeriodList[ranPeriodIndex],
    //     requestamount: +ranRequestAmountList[ranRequestAmountIndex],
    //     payPerMonth: +ranRequestAmountList[ranRequestAmountIndex],
    //     completedAt: executeTime,
    //     dueTime: getCurrentLocalDateTime(new Date()).isoDateTime,
    //     fullname: `${name} ${lastname}`,
    //     name: name,
    //     lastname: lastname,
    //     promo: 0,
    //     toDayTestGenLoan: currentDate,
    //   },
    //   headers: {
    //     Authorization: `Bearer ${(await Auth.currentSession())
    //       .getIdToken()
    //       .getJwtToken()}`,
    //   },
    // });
    await getData(query);
  };

  const getExclusiveStartKey = (index) => {
    return `loan_status=${datas[index].loan_status}&loan_id=${datas[index].loan_id}`;
  };

  const onChangeLimit = async (e) => {
    setPageSize(e);
    setPageIndex(0);
    let newQuery = {
      ...query,
      Limit: e.value,
    };
    delete newQuery?.ExclusiveStartKey;
    setQuery(newQuery);
    await getData(newQuery);
  };

  const onClickPrevPage = async () => {
    let newQuery = {
      ...query,
      Limit: +pageSize.value,
      countData: 1,
      ScanIndexForward: true,
    };
    if (pageType === "NEXT" && !datas.length) {
      newQuery = {
        ...newQuery,
      };
    } else {
      newQuery = {
        ...newQuery,
        ExclusiveStartKey: getExclusiveStartKey(0),
      };
    }
    setPageIndex((prev) => prev - 1);
    setPageType("PREV");
    await getData(newQuery, { sortBy: true, isLoading: true });
  };

  const onClickNextPage = async () => {
    const lastIndex = datas.length - 1;
    const newQuery = {
      ...query,
      countData: 1,
      ScanIndexForward: false,
      Limit: +pageSize.value,
      ExclusiveStartKey: getExclusiveStartKey(lastIndex),
    };
    setPageIndex((prev) => prev + 1);
    setPageType("NEXT");
    await getData(newQuery, { isLoading: true });
  };

  // const onImportExcel = async (importDatas, fileInfo) => {
  //   try {
  //     setLoadingImport(true);
  //     for (const importData of importDatas) {
  //       console.log("IM", importData);
  //       await API.post("MoneyHubAdmin", `/loan/importAccruedTwo`, {
  //         body: {
  //           ...importData,
  //           REFERENCE: `${importData.REFERENCE}`,
  //           INT_ACCRUE_DOC_DATE: `${importData.INT_ACCRUE_DOC_DATE}`,
  //           sendSap: `false`,
  //           checkZero: `false`,
  //           period: `${importData.period}`,
  //           CONTRACT_TYPE: `${pad(+importData.CONTRACT_TYPE)}`,
  //         },
  //         headers: {
  //           Authorization: `Bearer ${(await Auth.currentSession())
  //             .getIdToken()
  //             .getJwtToken()}`,
  //         },
  //       });
  //     }
  //     toast.success("ซิงค์ข้อมูล CSV สมบูรณ์");
  //   } catch (error) {
  //     console.log("ERROR", error);
  //   } finally {
  //     setLoadingImport(false);
  //   }
  // };

  const onClickExportExcelBuro = async () => {
    const csvLink = document.getElementById("csv-link");
    setLoadingExport(true);
    const data = await API.get("MoneyHubAdmin", "/loan/sandbox/creditBuro", {
      queryStringParameters: {
        currentDate,
      },
      headers: {
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
      },
    });

    // console.log("data", data);

    // data.filter((loan) => {
    //   const diffDefaultDate = differenceInDays(
    //     new Date(currentDate),
    //     new Date(loan.overdue_date)
    //   );
    //   console.log("diffDefaultDate", diffDefaultDate);
    //   console.log("loan id", loan.loan_kbank_id);
    //   return diffDefaultDate <= 1915; //มากกว่า 5ปี 90วัน
    // });
    setDataExport(
      // data
      data.filter((loan) => {
        const diffDefaultDate = differenceInDays(
          new Date(currentDate),
          new Date(loan.overdue_date)
        );
        return diffDefaultDate <= 1915; //มากกว่า 5ปี 90วัน
      })
      // data.filter((el) => el.loan_kbank_id === "94000007")
    );
    setLoadingExport(false);
    csvLink.click();
  };

  const getNamePnSegment = () => {
    let keep = [];
    let namePn = "";
    dataExport.forEach((data) => {
      const splitDate = data?.birthdateTh
        ? data.birthdateTh.split("/")
        : "01/01/1990".split("/");
      const year = +splitDate[2] - 543;
      const month = splitDate[1];
      const day = splitDate[0];
      const dateOfBirth = `${year}${month}${day}`;

      const namePnSegment = {
        pnSegmentTag: { fixedLength: 3, value: "N01", tag: "PN" },
        familyName: { fixedLength: 50, value: data.lastname, tag: "01" },
        firstName: { fixedLength: 30, value: data.name, tag: "04" },
        dateOfBirth: {
          fixedLength: 8,
          value: dateOfBirth,
          tag: "07",
        },
        customerType: {
          fixedLength: 1,
          value: "1",
          tag: "15",
        },
      };

      const idSegment = {
        idSegmentTag: { fixedLength: 3, value: "ID1", tag: "ID" },
        idType: { fixedLength: 2, value: "01", tag: "01" },
        idNumber: { fixedLength: 20, value: data?.citizenid || "", tag: "02" },
      };

      const addressSegment = {
        paSegmentTag: { fixedLength: 3, value: "A01", tag: "PA" },
        address_1: {
          fixedLength: 45,
          value:
            data.currentAddress?.length > 45
              ? data?.currentAddress?.slice(0, 45)
              : data.currentAddress,
          tag: "01",
        },
        address_2: {
          fixedLength: 45,
          value:
            data.currentAddress?.length > 45
              ? data?.currentAddress?.slice(45, data?.currentAddress?.length)
              : null,
          tag: "02",
        },
        country: { fixedLength: 4, value: "TH", tag: "07" },
      };

      const futureInstallments = data.installments.filter(
        (installment) =>
          installment.date > format(new Date(currentDate), "yyyy-MM-dd")
      );

      const futureInstallment = futureInstallments.length
        ? futureInstallments[0]
        : data.installments[data.installments.length - 1];

      let diffPastFuture =
        futureInstallment.actualPrinciple -
        futureInstallment.planPrinciple +
        futureInstallment?.interestMore;

      let amountPastDue = diffPastFuture <= 0 ? 0 : diffPastFuture;

      let checkDebt =
        data.overdue_date <= format(new Date(currentDate), "yyyy-MM-dd");

      let defaultDate = new Date(data.overdue_date);
      defaultDate.setDate(defaultDate.getDate() + 1);

      const diffOverDueDays = differenceInDays(
        new Date(currentDate),
        data.overdue_date ? new Date(data.overdue_date) : new Date()
      );
      let numberOfDate = "000"; //30
      if (diffOverDueDays >= 31 && diffOverDueDays <= 60) {
        numberOfDate = "001";
      } else if (diffOverDueDays >= 61 && diffOverDueDays <= 90) {
        numberOfDate = "002";
      } else if (diffOverDueDays >= 91 && diffOverDueDays <= 120) {
        numberOfDate = "003";
      } else if (diffOverDueDays >= 121 && diffOverDueDays <= 150) {
        numberOfDate = "004";
      } else if (diffOverDueDays >= 151 && diffOverDueDays <= 180) {
        numberOfDate = "005";
      } else if (diffOverDueDays >= 181 && diffOverDueDays <= 210) {
        numberOfDate = "006";
      } else if (diffOverDueDays >= 211 && diffOverDueDays <= 240) {
        numberOfDate = "007";
      } else if (diffOverDueDays >= 241 && diffOverDueDays <= 270) {
        numberOfDate = "008";
      } else if (diffOverDueDays >= 271 && diffOverDueDays <= 300) {
        numberOfDate = "009";
      } else if (diffOverDueDays > 300) {
        numberOfDate = "  F";
      }

      let accountStatus = 10;
      if (data.loan_status === "DONE") {
        accountStatus = 11;
      }

      let refinance_date = "";
      if (diffOverDueDays > 90) {
        accountStatus = 20;
        if (data?.refinance_amount > 0) {
          const temp_refinance_date = getCurrentLocalDateTime(
            new Date(data?.refinance_date)
          );
          refinance_date = `${pad(temp_refinance_date.year)}${pad(
            temp_refinance_date.month
          )}${pad(temp_refinance_date.date)}`;
        }
      }

      let currentInstallment = null;
      const currentInstallments = data.installments.filter(
        (installment, index) => {
          // const today = new Date(currentDate);
          // const splitDate = installment?.date?.split("-");
          // const month = splitDate[1];
          // return month === `${pad(today.getMonth() + 1)}`;
          const today = getCurrentLocalDateTime(new Date(currentDate));
          let checkInstallment =
            installment.date >=
            `${today.year}-${pad(today.month)}-${pad(today.date)}`;
          if (
            checkInstallment &&
            !installment.disabledPeriod &&
            !currentInstallment
          ) {
            currentInstallment = installment;
          }

          if (
            index === data.installments.length - 1 &&
            installment.disabledPeriod
          ) {
            currentInstallment = null;
          }

          return checkInstallment;
        }
      );

      if (!currentInstallment) {
        const latest_date = getCurrentLocalDateTime(
          new Date(data.installments[data.installments.length - 1].date)
        );
        const today = getCurrentLocalDateTime(new Date(currentDate));
        currentInstallment = { planPrinciple: 0, planInterest: 0 };
        if (
          `${pad(latest_date.month)}${pad(latest_date.year)}` ===
          `${pad(today.month)}${pad(today.year)}`
        ) {
          const installment = data.installments[data.installments.length - 1];
          currentInstallment = {
            planPrinciple: installment.planPrinciple,
            planInterest: installment.planInterest,
            actualPrinciple: installment.actualPrinciple,
            actualInterest: installment.actualInterest,
            interestMore: installment.interestMore,
          };
        }
        amountPastDue =
          futureInstallment.actualPrinciple +
          futureInstallment.interestMore +
          futureInstallment.actualInterest;
      }

      const temp_accumulated_interest = data?.temp_installments.reduce(
        (prev, installment) => {
          return installment.actualInterest + prev;
        },
        0
      );

      const total_paid_amount = data.evidence.reduce((prev, ev) => {
        return prev + ev.paid_amount;
      }, 0);

      let amountOwed = data?.installments.reduce((prev, installment) => {
        return (
          prev +
          installment.actualPrinciple +
          installment.actualInterest +
          installment.interestMore
        );
      }, 0);
      if (amountOwed < 0) {
        amountOwed = 0;
      }

      let installmentAmount =
        currentInstallment?.planInterest + currentInstallment?.planPrinciple;
      // +currentInstallment.interestMore;

      if (data.loan_status === "DONE") {
        installmentAmount = 0;
      }

      let default_date = "19000101";
      let dateAccountClosed = "19000101";
      if (data.loan_status === "ACTIVE" && checkDebt) {
        default_date = format(defaultDate, "yyyyMMdd");
        dateAccountClosed = format(new Date(data.endDate), "yyyyMMdd");
      }
      if (data?.refinance_amount > 0) {
        amountOwed = 0;
        amountPastDue = 0;
        accountStatus = 11;
        installmentAmount = 0;
        numberOfDate = "000";
        default_date = "19000101";
        dateAccountClosed = format(new Date(data.refinance_date), "yyyyMMdd");
      }

      if (data.loan_kbank_id == "94000007") {
        accountStatus = 30;
      }

      if (accountStatus === 11) {
        dateAccountClosed = "19000101";
      }

      const accountSegment = {
        tlSegmentTag: { fixedLength: 4, value: "T001", tag: "TL" },
        memberCode: { fixedLength: 10, value: "CC21070000", tag: "01" },
        memberName: { fixedLength: 16, value: "MHS", tag: "02" },
        accountNumber: {
          fixedLength: 25,
          value: data?.loan_kbank_id || "",
          tag: "03",
        },
        accountType: { fixedLength: 2, value: "05", tag: "04" },
        ownershipIndicator: { fixedLength: 1, value: "1", tag: "05" },
        currencyCode: { fixedLength: 3, value: "THB", tag: "06" },
        dateAccountOpened: {
          fixedLength: 8,
          value: format(new Date(data.requestTime), "yyyyMMdd"),
          tag: "08",
        },
        dateOfLastPayment: {
          fixedLength: 8,
          value: data?.paid_date_latest
            ? format(new Date(data.paid_date_latest), "yyyyMMdd")
            : "19000101",
          tag: "09",
        },
        dateAccountClosed: {
          fixedLength: 8,
          // value: "19000101",
          // value: !currentInstallments?.length
          //   ? format(
          //       new Date(data.installments[data.installments.length - 1].date),
          //       "yyyyMMdd"
          //     )
          //   : `${format(
          //       new Date(
          //         currentInstallments[currentInstallments.length - 1].date
          //       ),
          //       "yyyyMMdd"
          //     )}`,
          value: dateAccountClosed,
          tag: "10",
        },
        // asOfDate: {
        //   fixedLength: 8,
        //   value: data.paid_date_latest
        //     ? format(new Date(data.paid_date_latest), "yyyyMMdd")
        //     : "19000101",
        //   tag: "11",
        // },
        loanAmount: {
          fixedLength: 9,
          value: `${Number(data.requestamount)}`,
          tag: "12",
        },
        amountOwed: {
          fixedLength: 9,
          value:
            // `${Number(data.capitalRemain) + Number(data.interestMore)}`,
            data.loan_status === "DONE" ? "0" : `${amountOwed}`,
          tag: "13",
        },
        amountPastDue: {
          fixedLength: 9,
          value: `${Number(amountPastDue)}`,
          tag: "14",
        },
        numberOfDate: {
          fixedLength: 3,
          value: `${numberOfDate}`,
          tag: "15",
        },
        defaultDate: {
          fixedLength: 8,
          // value: "19000101",
          value: default_date,
          tag: "19",
        },
        installmentFrequency: {
          fixedLength: 1,
          value: "3",
          tag: "20",
        },
        installmentAmount: {
          fixedLength: 9,
          value: `${installmentAmount}`,
          //  !currentInstallments?.length
          //   ? data.installments[data.installments.length - 1].planPrinciple +
          //     data.installments[data.installments.length - 1].planInterest
          //   : `${
          //       currentInstallment?.planPrinciple +
          //       currentInstallment?.planInterest
          //     }`,
          // : `${currentInstallments[0].planPrinciple + }`,
          // value: `${Math.ceil(Number(data.requestamount / data.period))}`,
          tag: "21",
        },
        installmentNumberOfPayment: {
          fixedLength: 4,
          value: data.period > 10 ? `00${data.period}` : `000${data.period}`,
          tag: "22",
        },
        accountStatus: {
          fixedLength: 2,
          value: `${accountStatus}`,
          tag: "23",
        },
        loanObjective: {
          fixedLength: 5,
          value: "55555",
          tag: "32",
        },
        dateOfLastDebt: {
          fixedLength: 8,
          value: refinance_date ? `${refinance_date}` : "19000101",
          tag: "36",
        },
        numberOfCoBorrower: {
          fixedLength: 2,
          value: "00",
          tag: "39",
        },
      };

      const includeSegment = {
        ...namePnSegment,
        ...idSegment,
        ...addressSegment,
        ...accountSegment,
      };

      const keepSegment = {
        ...includeSegment,
        // namePnSegment,
        // idSegment,
        // addressSegment,
        // accountSegment,
      };

      keep.push(keepSegment);
      console.log("includeSegment", includeSegment);

      Object.keys(includeSegment).map((key) => {
        if (includeSegment[key]) {
          const item = includeSegment[key];
          if (item.value !== null) {
            var keepStr = "";
            if (item.value?.length > item?.fixedLength) {
              keepStr += item.value.slice(0, item.fixedLength);
            }
            namePn +=
              keepStr + `${item.tag}${pad(item.value.length)}${item.value}`;
          }
        }
      });
      namePn += `ES02**\n`;
    });
    return namePn;
  };

  const dataCsv = `${getHeaderTUDF({
    env: "test",
    dataExport,
    currentDate,
  })}\n${getDetailSegment({
    dataExport,
    currentDate: new Date(currentDate),
  })}TRLR`;

  const importOptions = {
    header: true,
    dynamicTyping: true,
    skipEmptyLines: true,
  };

  const onImportExcel = async (importDatas, fileInfo) => {
    setLoadingImport(true);

    for (const importData of importDatas) {
      let payloadTarget = {
        fullname: null,
        adminName: null,
        job_no: null,
        tx: null,
        transferDate: "",
      };

      const regexDate = /^\d{4}-\d{2}-\d{2}$/;

      if (!regexDate.test(importData?.transferDate)) {
        importData.transferDate = new Date();
      }

      const payloadSource = {
        fullname: importData.name,
        job_no: importData.job_no,
        adminName: user.username,
        tx: _.upperCase(importData.tx),
        transferDate: importData.transferDate,
      };

      Object.assign(payloadTarget, payloadSource);

      await API.put("MoneyHubAdmin", "/loanRequest/sandboxTx", {
        body: { ...payloadTarget },
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
        },
      });
    }
    await getData(query, { isLoading: false });
    setLoadingImport(false);
    toast.success("ซิงค์ข้อมูล CSV สมบูรณ์");
  };

  return (
    <ContainerContent>
      <button
        onClick={onClickGetLoan}
        className={classNames(
          "ml-2 border   duration-300 hover:text-whiteborder-green-500 p-1 px-2 rounded text-white hover:bg-green-600 bg-green-500  hover:text-white"
        )}
      >
        Gen Loan
      </button>
      <div className="ml-2">
        <CSVReader parserOptions={importOptions} onFileLoaded={onImportExcel} />
      </div>{" "}
      <input
        className="px-3 py-2 shadow border"
        type="date"
        value={currentDate}
        onChange={(e) => setCurrentDate(e.target.value)}
      />
      <CSVLink
        id="csv-link"
        hidden
        data={dataCsv}
        filename={`TUCRS-MHS-${format(new Date(currentDate), "yyyy-MM")}.txt`}
      />
      <button
        disabled={loadingExport}
        onClick={onClickExportExcelBuro}
        className={classNames(
          "ml-2 border p-1 px-2 rounded  text-white duration-300 ",
          {
            "border-yellow-500 cursor-pointer   hover:bg-yellow-600 bg-yellow-500  hover:text-white":
              !loadingExport,
            "bg-gray-500 cursor-not-allowed": loadingExport,
          }
        )}
      >
        {loadingExport ? "loading..." : "Export Buro"}
      </button>
      {!datas?.length ? (
        pageType === "NEXT" ? (
          <ContainerContent>
            <div className="text-gray-700 font-bold text-xl w-full text-center mt-20">
              สิ้นสุดรายการ
            </div>
            <div className="w-full mt-2 flex items-center">
              {" "}
              <button
                className="bg-blue-500 text-xl p-4  mx-auto text-white mt-2 "
                onClick={onClickPrevPage}
              >
                ย้อนกลับ
              </button>
            </div>
          </ContainerContent>
        ) : (
          <ContainerContent>
            <DataEmpty />
          </ContainerContent>
        )
      ) : (
        <React.Fragment>
          <div className="flex w-full p-4 pt-0">
            <div className=" flex justify-between gap-4 ">
              <nav
                className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px"
                aria-label="Pagination"
              >
                <PrevPage
                  canPreviousPage={pageIndex !== 0}
                  onClick={onClickPrevPage}
                />
                <NumberPage number={pageIndex} pageIndex={pageIndex} />
                <NextPage onClick={onClickNextPage} canNextPage={true} />
              </nav>
              <div className="w-24 flex">
                <SelectRows
                  pageSize={pageSize}
                  onChange={onChangeLimit}
                  options={optionsLimit}
                />
              </div>
            </div>
          </div>
          <LoanSandboxTable
            currentDate={currentDate}
            selectedRows={selectedRows}
            setSelectedRows={setSelectedRows}
            // overdueDateMax={query.max}
            overDueDate={query.overDueDate}
            data={datas}
            getData={getData}
            query={query}
          />
        </React.Fragment>
      )}
    </ContainerContent>
  );
}

export default Sandbox5;
